var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_CONFIG = "api/config";
export const getTaxPresets = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign({ headers: { Authorization: `Bearer ${this.apiToken}` } }, ((params === null || params === void 0 ? void 0 : params.country)
                ? {
                    params: {
                        country: params.country,
                    },
                }
                : {}));
            return yield this.axiosInstance.get(`${GET_SET_CONFIG}/tax-presets`, config);
        }
        catch (error) {
            console.error("Error fetching getTaxPresets:", error);
            throw error;
        }
    });
};
